import * as DateFns from "date-fns";
import { DEFAULT_DATE_TYPE_FORMAT } from "src/constants/date";
import { z } from "zod";

export const DateWithoutTime = z
  .string({
    invalid_type_error: `Date format must be ${DEFAULT_DATE_TYPE_FORMAT}`,
  })
  .refine((value) => DateFns.isMatch(value, DEFAULT_DATE_TYPE_FORMAT));
